/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} TotalInputs */

const en_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const th_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ยอดรวม`)
};

const ja_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合計`)
};

const fr_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const es_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Total`)
};

const ru_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Итого`)
};

const zh_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`合计`)
};

const vi_total = /** @type {(inputs: TotalInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tổng cộng`)
};

/**
* | output |
* | --- |
* | "Total" |
*
* @param {TotalInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const total = /** @type {((inputs?: TotalInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<TotalInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_total(inputs)
	if (locale === "ja") return ja_total(inputs)
	if (locale === "fr") return fr_total(inputs)
	if (locale === "es") return es_total(inputs)
	if (locale === "ru") return ru_total(inputs)
	if (locale === "zh") return zh_total(inputs)
	if (locale === "vi") return vi_total(inputs)
	return en_total(inputs)
});